module.exports = __webpack_public_path__ + "static/img/code.c32a3a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/code.jpg
// module id = 0TyE
// module chunks = 1